// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"8335e709","150":"f340fe8e","545":"73c5713a","551":"a8c588d1","605":"5af00972","662":"36119cb3"}[chunkId] + ".chunk.js";
};